import { t } from '@hefe/i18n';
import {
  BasketballPracticesSlice,
  ModalsSlice,
  userActiveBasketballCoachTeamId,
} from '@hefe/store';
import { formatDatabaseDate } from '@hefe/utils';
import { Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

export default function LinkPracticesForm() {
  const dispatch = useAppDispatch();

  const [refresh, doRefresh] = useState(false);
  const activeCoachTeamId = useSelector(userActiveBasketballCoachTeamId);

  useEffect(() => {
    doRefresh((prev) => !prev);
  }, [activeCoachTeamId]);

  const formKey = `link-practices-form`;

  const onSubmit = (values: any, resetForm: any) => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;
    const close = ModalsSlice.modalsActions.closeModal;

    dispatch(setLoading(true));
    dispatch(
      BasketballPracticesSlice.linkBasketballPractices({
        teamId: activeCoachTeamId ?? 0,
        request: {
          date_till: formatDatabaseDate(values.date),
          description: values.description,
        },
      })
    )
      .unwrap()
      .then(() => dispatch(close()))
      .finally(() => dispatch(setLoading(false)));
  };

  return (
    <div>
      <Typography.Paragraph>{t('practices.link_info')}</Typography.Paragraph>
      <CustomForm
        key={formKey}
        formId={formKey}
        refresh={refresh}
        fields={[
          {
            name: 'date',
            label: t('date'),
            type: 'date',
            rules: [
              {
                required: true,
                message: t('form_errors.date'),
              },
            ],
          },
          {
            name: 'description',
            label: t('note'),
            type: 'text',
            rules: [],
          },
        ]}
        onSubmit={onSubmit}
      />
    </div>
  );
}
